import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/configs";
import { Avail, AvailEpisodesPayload, AvailEpisodeView } from "../deal-terms-details.interface";

@Injectable()
export class AvailEpisodesService {
    constructor(private httpClient: HttpClient) {
    }

    public loadForAvailId(availId: number): Observable<AvailEpisodeView[]> {
        return this.httpClient
            .get<AvailEpisodeView[]>(`${environment.apiPath}/availEpisodes?availId=${availId}`)
    }

    public patchAvail(availId: number, availEpisodesPayload: AvailEpisodesPayload): Observable<Avail> {
        return this.httpClient.put<Avail>(`${environment.apiPath}/avails/${availId}`, availEpisodesPayload);
    }
}
